import { createAsyncThunk } from '@reduxjs/toolkit';
import { deleteFloorplanPlacement as deleteFloorplanPlacementService } from '../services/deleteFloorplanPlacement.service';

export const deleteFloorplanPlacement = createAsyncThunk(
  'floorplans/deleteFloorplanPlacement',
  async ({ projectId, placementId }, { rejectWithValue }) => {
    try {
      await deleteFloorplanPlacementService(projectId, placementId);
      return { id: placementId };
    } catch (err) {
      return rejectWithValue({ message: err.message, placementId });
    }
  }
);
